import BaseLayout from './Layout.Base';

export default BaseLayout;
